import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroEntregas = async (fechaStart,fechaEnd , idRecolector) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/entregas?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idRecolector=${idRecolector}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroEntrega = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/entregas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroEntrega = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/entregas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroEntrega = (Id) => Axios.delete(`/entregas/${Id}`);